import React from 'react';
import { Box } from '@mui/material';

interface HemisphereProps {
  radius?: number;
  unit?: string;
  color?: string;
  strokeColor?: string;
}

export const Hemisphere: React.FC<HemisphereProps> = ({
  radius = 3,
  unit = 'cm',
  color = '#DDA0DD',
  strokeColor = '#9c27b0'
}) => {
  const cx = 50;
  const cy = 60; // Shift down slightly because it's only top half
  
  const scale = 40 / (radius * 2);
  const R = radius * scale;
  
  const r_proj = R * Math.sqrt(1.5);
  const rx = r_proj;
  const ry = R * Math.SQRT1_2;

  const domePath = `M ${cx - rx} ${cy} A ${r_proj} ${r_proj} 0 0 1 ${cx + rx} ${cy}`;
  const frontBasePath = `M ${cx - rx} ${cy} A ${rx} ${ry} 0 0 0 ${cx + rx} ${cy}`;
  const backBasePath = `M ${cx - rx} ${cy} A ${rx} ${ry} 0 0 1 ${cx + rx} ${cy}`;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid meet"
        style={{ width: '100%', maxWidth: '320px', height: '320px', display: 'block' }}
      >
        <defs>
          <radialGradient id="hemiGrad" cx="35%" cy="35%" r="65%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity={0.8} />
            <stop offset="50%" stopColor={color} stopOpacity={0.85} />
            <stop offset="100%" stopColor={color} stopOpacity={1.0} />
          </radialGradient>
        </defs>

        {/* Hidden back edge */}
        <path d={backBasePath} fill="none" stroke={strokeColor} strokeWidth={1} strokeDasharray="2,2" opacity={0.5} />

        {/* Dome Body */}
        <path d={`${domePath} A ${rx} ${ry} 0 0 0 ${cx - rx} ${cy} Z`} fill="url(#hemiGrad)" />

        {/* Visible Edges */}
        <path d={domePath} fill="none" stroke={strokeColor} strokeWidth={1.5} />
        <path d={frontBasePath} fill="none" stroke={strokeColor} strokeWidth={1.5} />

        {/* Center point and radius line */}
        <circle cx={cx} cy={cy} r={1.2} fill={strokeColor} />
        <line x1={cx} y1={cy} x2={cx + rx} y2={cy} stroke={strokeColor} strokeWidth={1.5} strokeDasharray="1,2" opacity={0.8} />
        <text x={cx + rx / 2} y={cy - 2} fontSize={3.5} fill="#374151" fontWeight={600} textAnchor="middle">r = {radius} {unit}</text>
      </svg>
    </Box>
  );
};

export default Hemisphere;
